import boldTtf from './SuisseIntl-Bold.ttf';
import boldWoff from './SuisseIntl-Bold.woff';
import boldWoff2 from './SuisseIntl-Bold.woff2';
import lightTtf from './SuisseIntl-Light.ttf';
import lightWoff from './SuisseIntl-Light.woff';
import lightWoff2 from './SuisseIntl-Light.woff2';
import mediumTtf from './SuisseIntl-Medium.ttf';
import mediumWoff from './SuisseIntl-Medium.woff';
import mediumWoff2 from './SuisseIntl-Medium.woff2';
import regularTtf from './SuisseIntl-Regular.ttf';
import regularWoff from './SuisseIntl-Regular.woff';
import regularWoff2 from './SuisseIntl-Regular.woff2';
import semiBoldTtf from './SuisseIntl-SemiBold.ttf';
import semiBoldWoff from './SuisseIntl-SemiBold.woff';
import semiBoldWoff2 from './SuisseIntl-SemiBold.woff2';

// setup @font-face rules
export const suisseLight: any = {
  fontFamily: 'SuisseIntl-Light',
  fontWeight: 300,
  src: `
    local('SuisseIntl'),
    local('SuisseIntl-Light'),
    url(${lightWoff}) format('woff'),
    url(${lightWoff2}) format('woff2'),
    url(${lightTtf}) format('truetype')
  `,
};

export const suisseRegular: any = {
  fontFamily: 'SuisseIntl-Regular',
  fontWeight: 400,
  src: `
    local('SuisseIntl'),
    local('SuisseIntl-Regular'),
    url(${regularWoff}) format('woff'),
    url(${regularWoff2}) format('woff2'),
    url(${regularTtf}) format('truetype')
  `,
};
export const suisseMedium: any = {
  fontFamily: 'SuisseIntl-Medium',
  fontWeight: 500,
  src: `
    local('SuisseIntl'),
    local('SuisseIntl-Medium'),
    url(${mediumWoff}) format('woff'),
    url(${mediumWoff2}) format('woff2'),
    url(${mediumTtf}) format('truetype')
  `,
};
export const suisseSemiBold: any = {
  fontFamily: 'SuisseIntl-SemiBold',
  fontWeight: 600,
  src: `
    local('SuisseIntl'),
    local('SuisseIntl-SemiBold'),
    url(${semiBoldWoff}) format('woff'),
    url(${semiBoldWoff2}) format('woff2'),
    url(${semiBoldTtf}) format('truetype');
  `,
};
export const suisseBold: any = {
  fontFamily: 'SuisseIntl-Bold',
  fontWeight: 700,
  src: `
    local('SuisseIntl'),
    local('SuisseIntl-Bold'),
    url(${boldWoff}) format('woff'),
    url(${boldWoff2}) format('woff2'),
    url(${boldTtf}) format('truetype')
  `,
};

// base font family w/ fallbacks
export const fontFamily: string[] = [
  'Helvetica',
  'Arial',
  'sans-serif',
];

// setup reusable font family weight variants w/ above fallbacks
export const fontBold: string = ['SuisseIntl-Bold', ...fontFamily].join(',');
export const fontSemiBold: string = ['SuisseIntl-SemiBold', ...fontFamily].join(',');
export const fontMedium: string = ['SuisseIntl-Medium', ...fontFamily].join(',');
export const fontRegular: string = ['SuisseIntl-Regular', ...fontFamily].join(',');
export const fontLight: string = ['SuisseIntl-Light', ...fontFamily].join(',');

// setup typography variants (:rocket BrandDNA)
export const h1: any = {
  fontFamily: fontBold,
  fontSize: 56,
  lineHeight: '72px',
  letterSpacing: -1.2,
};
export const h2: any = {
  fontFamily: fontBold,
  fontSize: 44,
  lineHeight: '60px',
  letterSpacing: -0.5,

};
export const h3: any = {
  fontFamily: fontBold,
  fontSize: 32,
  lineHeight: '46px',
  letterSpacing: -0.5,
};
export const h4: any = {
  fontFamily: fontSemiBold,
  fontSize: 26,
  lineHeight: '40px',
  letterSpacing: -0.5,
};
export const h5: any = {
  fontFamily: fontSemiBold,
  fontSize: 20,
  lineHeight: '30px',
  letterSpacing: 0,
};
export const h6: any = {
  fontFamily: fontSemiBold,
  fontSize: 16,
  lineHeight: '26px',
  letterSpacing: 0,
};
export const subheading1: any = {
  fontFamily: fontRegular,
  fontSize: 24,
  lineHeight: '36px',
  letterSpacing: 0,
};
export const subheading2: any = {
  fontFamily: fontRegular,
  fontSize: 20,
  lineHeight: '32px',
  letterSpacing: 0,
};
export const body1: any = {
  fontFamily: fontRegular,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: 0.4,
};
export const body2: any = {
  fontFamily: fontRegular,
  fontSize: 14,
  lineHeight: '24px',
  letterSpacing: 0.3,
};
export const caption: any = {
  fontFamily: fontRegular,
  fontSize: 12,
  lineHeight: '16px',
  letterSpacing: 0.5,
};
export const overline: any = {
  fontFamily: fontSemiBold,
  fontSize: 10,
  lineHeight: '16px',
  letterSpacing: 1,
  textTransform: 'uppercase',
};
export const button: any = {
  fontFamily: fontSemiBold,
  fontSize: 14,
  lineHeight: '1.75',
};

// TODO: make this obsolete
export const captionAlt: any = {
  ...caption,
  fontSize: 12,
  textTransform: 'inherit',
};
